var PalantirContentComponent = /** @class */ (function () {
    function PalantirContentComponent() {
    }
    return PalantirContentComponent;
}());
export { PalantirContentComponent };
